export default __webpack_public_path__ + "static/media/lesson-builder.cf4466a5.svg";